import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { CustomerService } from '../../services/customer.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    if (oid == 0) {
        record.set({ oid: 0, code: '', name: '', address: '', zipCode: '', city: '', province: '', fiscalCode: '', vatNumber: '', notes: '', clfCustomerType: null });
    }
    else {
        let _resp = await CustomerService.fetchCustomer(oid);
        record.set(_resp.payload);
        await loadStats(oid);
    }
}
async function loadStats(customerOid) {
    let _resp = await CustomerService.fetchCustomerStats(customerOid);
    stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await CustomerService.getCustomers(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    // console.log("onCreate");
    navigate(`/customer/0`);
}
export function onEdit(item) {
    // console.log("onEdit", item);
    navigate(`/customer/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return await CustomerService.saveCustomer(_record);
}
export async function onDelete(item) {
    // console.log("onDelete", item);
    await CustomerService.deleteCustomer(item.oid);
    await load();
}
export function onPageChange(pageNumber) {
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
